import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { Header } from '@core/layout/header/header';
import { Footer } from '@core/layout/footer/footer';
import { LandingCmsService } from '@core/cms/landing-cms.service';
import { SeoService } from '@core/seo/seo.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, Header, Footer],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App {
    private readonly _landing: LandingCmsService = inject(LandingCmsService);
    // Eagerly instantiated so its route-tracking effect runs app-wide (canonical/og:url default to
    // the current URL on every route), not only on pages that consume it directly.
    private readonly _seo: SeoService = inject(SeoService);

    /** Landing CMS resource (header/footer bindings live in the template). */
    protected readonly landing: LandingCmsService['landing'] = this._landing.landing;
}
